<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img :src="currentUser.avatar" class="img-avatar" :alt="currentUser.email" />
    </template>
    <template slot="dropdown">
      <!-- <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header> -->
      <template v-if="currentUser.isAgency">
        <b-dropdown-header tag="div" class="text-center">
          <strong>Settings</strong>
        </b-dropdown-header>
        <b-dropdown-item to='/users'><i class="fa fa-users"/> Manage Users</b-dropdown-item>
      </template>
      <template>
        <b-dropdown-item v-if="signedAsName"><i class="fa fa-user"/>Logged in as {{signedAsName}}</b-dropdown-item>
      </template>
      <b-dropdown-item v-if='currentUser.isAdmin' to='/switch_user'><i class="fa fa-users"/> Switch User</b-dropdown-item>

      <!-- <b-dropdown-item><i class="fa fa-user" /> Profile</b-dropdown-item> -->
      <!-- <b-dropdown-item><i class="fa fa-wrench" /> Settings</b-dropdown-item> -->
      <b-dropdown-item v-on:click="logout"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import axios from '../backend'
import { mapGetters } from 'vuex'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown,
    axios
  },

  data () {
    return {
      users: [],
      signedAsName: null
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'currentUser'
    })

  },

  created () {
    this.$eventBus.$on('switchUser', this.updateSignedAsName)
    this.loadUsers()
  },

  methods: {
    updateSignedAsName () {
      var userId = axios.defaults.headers['SignAsUserId']
      if (userId){
        userId = parseInt(userId, 10)
        this.users.forEach(function(user){
          if (parseInt(user.id, 10) === userId){
            this.signedAsName = user.first_name + ' ' + user.last_name
          }
        }.bind(this))
      } else {
        this.signedAsName = null
      }
    },

    logout () {
      this.$store.commit('logout')
      this.$router.push('/login')
    },

    loadUsers () {
      this.$http.get('/users?switch_user=1')
        .then(function(response){
          this.users = response.data
        }.bind(this))
    },
  }
}
</script>
